import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LegacyTaskDetailsComponent } from './details/details.component';
import { FeatureFlag, Module, NewPermission } from '@core/enums';
import { Store } from '@ngxs/store';
import { UserState } from '@state/user/state';
import { AccountState } from '@state/account/state';

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateTasksDetails {
  canDeactivate(
    component: LegacyTaskDetailsComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Get the next route
    let nextRoute: ActivatedRouteSnapshot = nextState.root;
    while (nextRoute.firstChild) {
      nextRoute = nextRoute.firstChild;
    }

    // If the next state doesn't contain '/tasks'
    // it means we are navigating away from the
    // tasks app
    if (!nextState.url.includes('/tasks')) {
      // Let it navigate
      return true;
    }

    // If we are navigating to another task...
    if (nextRoute.paramMap.get('task_id')) {
      // Just navigate
      return true;
    }
    // Otherwise...
    else {
      // Close the drawer first, and then navigate
      component.closeDrawer();
      return true;
    }
  }
}

@Injectable({ providedIn: 'root' })
export class CanActivateTaskSettings {
  constructor(
    private readonly store: Store,
    private readonly router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.store.selectSnapshot(AccountState.isFeatureEnabled(FeatureFlag.NEW_PERMISSIONS))) {
      if (route.data.module === Module.GLOBAL_TASKS) {
        if (!this.store.selectSnapshot(UserState.hasPermission(NewPermission.GLOBAL_TASK_LISTS_EDIT))) {
          this.router.navigate(['unauthorized']);
          return false;
        }
      } else {
        if (!this.store.selectSnapshot(UserState.hasPermission(NewPermission.AGGREGATED_TASK_LISTS_EDIT))) {
          this.router.navigate(['unauthorized']);
          return false;
        }
      }
    }

    return true;
  }
}
